import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WebTempTermoExtratoDesligamento } from '../models/WebTempTermoExtratoDesligamento.model';
import { environment } from 'environments/environment';
import { WebTempTermoExtratoContribAutopatrocinio } from '../models/WebTempTermoExtratoContribAutopatrocinio.model';
import { WebTempTermoExtratoBPD } from '../models/WebTempTermoExtratoBPD.model';

@Injectable({
  providedIn: 'root'
})
export class WebTempTermoExtratoBPDService {
  private strAction = 'api/WebTempTermoExtratoDesligamento';

  constructor(private http: HttpClient) {

  }
//http://localhost:40320/api/WebTempTermoExtratoBPD/GetById/1
  public getById(idTermo: number): Observable<WebTempTermoExtratoBPD> {
    return this.http.get<WebTempTermoExtratoBPD>(`${environment.TrustCRMApiHost}api/WebTempTermoExtratoBPD/GetById/${idTermo}`);
  }
}


